import { FC, useRef, useState } from 'react';
import { useClickAway } from 'react-use';

const SearchBar: FC<{
  searchValue: string | undefined;
  onClickFunction: (searchValue: string) => void;
  onClearFunction?: () => void;
}> = ({
  searchValue,
  onClickFunction,
  onClearFunction
}: {
  searchValue: string | undefined;
  onClickFunction: (searchValue: string) => void;
  onClearFunction?: () => void;
}) => {
  const [searchTerm, setSearchTerm] = useState(searchValue ?? '');

  return (
    <>
      <form
        className="grow md:grow-0"
        onSubmit={(e) => {
          e.preventDefault();
          onClickFunction(searchTerm);
        }}
      >
        <div className="relative">
          <span className="absolute inset-y-0 left-0 flex items-center text-navy pl-2.5 bg-transparent cursor-pointer">
            <button
              type="submit"
              className=""
              id="searchButton"
              onClick={(e) => {
                e.preventDefault();
                onClickFunction(searchTerm);
              }}
            >
              <i className="ra-icons-generic-search text-neutral-500 flex"></i>
            </button>
          </span>
          <input
            value={searchTerm}
            type="search"
            className="pl-8 px-4 py-2 border border-neutral-200 rounded bg-neutral-50 focus:bg-white w-full md:w-60 focus:w-85 focus:border-neutral-500 transition-all"
            placeholder="Search..."
            id="searchBarValue"
            name="searchBarValue"
            onChange={(e) => {
              e.preventDefault();
              setSearchTerm(e.currentTarget.value);
            }}
          />
          {onClearFunction && searchTerm ? (
            <button
              className="absolute inset-y-0 right-0 flex items-center pr-2.5 bg-transparent"
              onClick={(e) => {
                e.preventDefault();
                setSearchTerm('');
                onClearFunction();
              }}
            >
              <i className="ra-icons-generic-cross-1 text-primary-700 flex"></i>
            </button>
          ) : null}
        </div>
      </form>
    </>
  );
};

export default SearchBar;
